import React, { useRef, useState } from 'react';
import { cn } from '../../utils/helper';

export default function DragDropFileInput({
  accept,
  hint,
  onChange,
  disabled = false,
  uploading = false,
  uploadingText = 'Uploading...',
  icon,
  className,
  error,
}) {
  const [dragging, setDragging] = useState(false);
  const inputRef = useRef(null);

  const isImage = accept?.toLowerCase().includes('image');
  const dropLabel = isImage ? 'Drop your image here' : 'Drop your video here';

  function processFile(file) {
    if (file && !disabled && !uploading) onChange(file);
  }

  function handleDragOver(e) {
    if (disabled || uploading) return;
    e.preventDefault();
    e.stopPropagation();
    setDragging(true);
  }

  function handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
  }

  function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    setDragging(false);
    if (disabled || uploading) return;
    processFile(e.dataTransfer.files?.[0]);
  }

  const isInteractive = !disabled && !uploading;

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        disabled={!isInteractive}
        onChange={(e) => processFile(e.target.files?.[0])}
      />
      <div
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        onClick={() => isInteractive && inputRef.current?.click()}
        className={cn(
          'flex flex-col justify-center items-center overflow-hidden rounded-lg border-2 border-dashed w-full h-[240px] relative transition-colors',
          dragging
            ? 'border-shoorah-primary bg-blue-50 dark:bg-shoorah-darkBgColor'
            : 'border-gray-300 dark:border-gray-600 bg-white dark:bg-shoorah-darkBgTabColor',
          isInteractive ? 'cursor-pointer hover:border-shoorah-primary' : 'cursor-default',
          className
        )}
      >
        {uploading ? (
          <p className="text-shoorah-primary text-sm">{uploadingText}</p>
        ) : (
          <>
            {icon}
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {dropLabel}, or{' '}
              <span className="text-shoorah-primary font-medium">browse</span>
            </p>
            {hint && <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">{hint}</p>}
          </>
        )}
      </div>
      {error && <span className="text-red-500 text-[12px] mt-1 block">{error}</span>}
    </>
  );
}
